import React from 'react';

import { GeneralEventMap } from '@vlabs/monokit/entities/events/map';
import { GeneralEventVideoArchive } from '@vlabs/monokit/widgets/video-archive';

import st from './VideoAnalyticsEventView.module.sass';
import { useSelectedWorkspaceEvent } from '../useSelectedWorkspaceEvent.js';
import { VideoAnalyticsDetails } from './details/VideoAnalyticsDetails';

export function VideoAnalyticsEventView(): React.JSX.Element {
  const { event } = useSelectedWorkspaceEvent();

  return (
    <div className={st.EventInfo}>
      <div className={st.Details}>
        <VideoAnalyticsDetails event={event} />
      </div>

      <div className={st.Archive}>
        <GeneralEventVideoArchive
          startTime={event?.create_time}
          streamId={event?.event?.stream_id}
        />
      </div>

      <div className={st.Map}>
        <GeneralEventMap event={event} />
      </div>
    </div>
  );
}
